import i18next from 'i18next'

export const localize = <K extends string>(key: K): string => i18next.t(key)
